import { Box } from '@chakra-ui/layout'
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Text as ChakraText,
  Divider,
} from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import type { AnalyticsAPIResponse } from '../../interfaces'
import {
  TopCountriesTable,
  TopBrowsersTable,
  TopFormatsTable,
  TopDevicesTable,
  TopUserAgentsTable,
  TopReferrersTable,
  TopIPAddressesTable,
} from '.'

interface Props {
  data: AnalyticsAPIResponse
  showBandwidth: Boolean
}

const TopUsage = ({ data, showBandwidth }: Props): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <Box marginTop="2.5rem">
      <ChakraText fontWeight="semibold" marginBottom="0.75rem" fontSize="16px">
        {t('top_usage', 'Top Usage')}
      </ChakraText>
      <Divider />
      <Tabs
        variant="soft-rounded"
        size="sm"
        marginTop="1rem"
        colorScheme="appBlue"
        isLazy={true}
        lazyBehavior="unmount"
      >
        <TabList>
          <Tab>{t('by_countries', 'By countries')}</Tab>
          <Tab>{t('by_browsers', 'By browsers')}</Tab>
          <Tab>{t('by_formats', 'By formats')}</Tab>
          <Tab>{t('by_devices', 'By devices')}</Tab>
          <Tab>{t('by_user_agent', 'By user agents')}</Tab>
          <Tab>{t('by_referrer', 'By referrers')}</Tab>
          <Tab>{t('by_ip_address', 'By IP addresses')}</Tab>
        </TabList>
        <TabPanels>
          <TabPanel marginTop="1rem" padding="0">
            <TopCountriesTable {...{ data, showBandwidth }} />
          </TabPanel>
          <TabPanel marginTop="1rem" padding="0">
            <TopBrowsersTable {...{ data }} />
          </TabPanel>
          <TabPanel marginTop="1rem" padding="0">
            <TopFormatsTable {...{ data }} />
          </TabPanel>
          <TabPanel marginTop="1rem" padding="0">
            <TopDevicesTable {...{ data, showBandwidth }} />
          </TabPanel>
          <TabPanel marginTop="1rem" padding="0">
            <TopUserAgentsTable {...{ data }} />
          </TabPanel>
          <TabPanel marginTop="1rem" padding="0">
            <TopReferrersTable {...{ data }} />
          </TabPanel>
          <TabPanel marginTop="1rem" padding="0">
            <TopIPAddressesTable {...{ data }} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  )
}

export default TopUsage
